// extracted by mini-css-extract-plugin
export var modal = "_vj-0";
export var table = "_vj-1";